"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsThumbnailTooltipDisabled = exports.getThumbnailTooltipI18nKey = void 0;

var _fileAccessibility = require("./fileAccessibility");

var _file = require("./file");

var getThumbnailTooltipI18nKey = function getThumbnailTooltipI18nKey(file) {
  var isHostAppContextPrivate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var tooltipI18nKey = 'FileManagerLib.generatingThumbnailInsertTooltip';

  if ((0, _file.getIsSvg)(file) && (0, _file.getIsSvgTooLarge)(file)) {
    tooltipI18nKey = 'FileManagerCore.tooltips.fileTooLargeToPreview';
  }

  if ((0, _fileAccessibility.getIsFilePrivate)(file) && !isHostAppContextPrivate) {
    tooltipI18nKey = 'FileManagerLib.privateFileInsertTooltip';
  }

  if ((0, _fileAccessibility.getIsFileExternal)(file)) {
    tooltipI18nKey = 'FileManagerLib.externalFileInsertTooltip';
  }

  return tooltipI18nKey;
};

exports.getThumbnailTooltipI18nKey = getThumbnailTooltipI18nKey;

var getIsThumbnailTooltipDisabled = function getIsThumbnailTooltipDisabled(file) {
  var isHostAppContextPrivate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if ((0, _file.getIsSvg)(file) && (0, _file.getIsSvgTooLarge)(file)) {
    return false;
  }

  if ((0, _fileAccessibility.getIsFilePrivate)(file) && !isHostAppContextPrivate) {
    return false;
  }

  if ((0, _fileAccessibility.getIsFileExternal)(file)) {
    return false;
  }

  return true;
};

exports.getIsThumbnailTooltipDisabled = getIsThumbnailTooltipDisabled;